import React from 'react';
import TrendsWrapper from 'domain/staffing/dashboard/dashboard/shared/staffingContent/trends/TrendsWrapper';
import { ControlledShow } from 'framework/show';
import { useStaffingProjectContext } from '../context/StaffingProjectContext';

const StaffingProjectTrendsPage = () => {
  const { staffingData } = useStaffingProjectContext();

  if (!staffingData) return null;

  return (
    <ControlledShow data={staffingData}>
      <TrendsWrapper />
    </ControlledShow>
  );
};

export default StaffingProjectTrendsPage;
